export default __webpack_public_path__ + "static/media/Datchik-otkrytiya-i-zakrytiya.a58c83ea.webp";